import 'bootstrap';

//
// Mock a jQuery accessor to allow webpack building
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

$.ajaxSetup({
	headers: {
		'X-CSRF-TOKEN': $('meta[name="csrf"]').attr('content')
	}
});

$(document).ajaxComplete((event, xhr, settings, error) => {
	const data = xhr.responseJSON;

	if (!data) return;

	if (data.redirect) {
		location.href = data.redirect;
		return;
	}

	if (data.notification) {
		document.querySelector('[data-id="notification-wrapper"]').insertAdjacentHTML('beforeend', data.notification.html);
		$(`.toast[data-notification-uuid="${ data.notification.uuid }"]`).toast('show');
	}
});

//
// Fix bootstrap multiple modal bug
$(document).on('shown.bs.modal', checkForOpenModals);
$(document).on('hidden.bs.modal', checkForOpenModals);

function checkForOpenModals(event) {
	if ($('.modal.show').length > 0) {
		$('body').addClass('modal-open');
	}
}

//
// Inject the ziggy route utility core
import { Ziggy } from './ziggy';
window.Ziggy = Ziggy;

//
// Inject the ziggy route helper
import route from 'ziggy';
window.route = route;

//
// Inject moment for time calculations
import moment from 'moment';
window.moment = moment;
window.moment.locale('de');

//
// Reserve a duo namespace for plugins to use
window.duo = {};

require('./vendor/idle.min.js');

require('./core/token.js');
require('./core/dropdown.js');
require('./core/generator.js');
require('./core/href.js');
require('./core/searchable-table.js');
require('./core/sortable-table.js');
require('./core/tooltip.js');

//
// Requiring to ensure the right order for event registration
require('./core/uncheckable-radio-button.js');
require('./core/disclosable.js');

require('./form/autocomplete-place.js');
require('./form/datepicker-raw.js');
require('./form/datepicker.js');
require('./form/slider.js');
require('./form/validation.js');
require('./form/table.js');
require('./form/subtype.js');
require('./form/study-scripting-scope.js');

import CatalogRegistry from './core/catalog.js';
window.CatalogRegistry = CatalogRegistry;

$(function () {
	window.CatalogRegistry = new CatalogRegistry();
})
